(()=>{'use strict';
const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(c/100);
const root=()=>(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

function ready(){
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const progress=document.getElementById('progress');
  if(!reduced&&'IntersectionObserver'in window){
    document.body.classList.add('js-ready');
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('seen');io.unobserve(e.target)}}),{threshold:.07});
    document.querySelectorAll('.reveal').forEach(el=>{io.observe(el);if(el.getBoundingClientRect().top<innerHeight*.9)el.classList.add('seen')});
  }
  if(progress)window.addEventListener('scroll',()=>{const max=Math.max(document.documentElement.scrollHeight-innerHeight,1);progress.style.width=Math.min(100,scrollY/max*100)+'%'},{passive:true});
  document.querySelectorAll('.hmd-product-picker').forEach(setupPicker);
  document.querySelectorAll('[data-hmd-cart]').forEach(setupCart);
  const msg=document.querySelector('[data-hmd-autofocus]');
  if(msg){msg.scrollIntoView({block:'center'});msg.focus({preventScroll:true})}
}

function setupPicker(picker){
 const radios=[...picker.querySelectorAll('.hmd-variants input[type="radio"]')];
 const personalize=picker.querySelector('[data-hmd-personalize]');
 const fields=picker.querySelector('[data-hmd-person-fields]');
 const initials=picker.querySelector('[data-hmd-initials]');
 const total=picker.querySelector('[data-hmd-total]');
 const button=picker.querySelector('[data-hmd-add]');
 const feedback=picker.querySelector('[data-hmd-feedback]');
 if(!button||!radios.length)return;
 const addonId=Number(picker.dataset.addonVariant||0);
 const addonPrice=Number(picker.dataset.addonPrice||0);
 const selected=()=>radios.find(x=>x.checked&&!x.disabled)||radios.find(x=>!x.disabled);
 if(!radios.some(x=>x.checked&&!x.disabled)){const first=radios.find(x=>!x.disabled);if(first)first.checked=true;}
 const wantsInitials=()=>!!(personalize&&personalize.checked&&addonId);
 function update(){
  const item=selected();
  if(!item){button.disabled=true;return}
  const extra=wantsInitials()?Number(item.dataset.units)*addonPrice:0;
  if(total)total.textContent=money(Number(item.dataset.price)+extra);
  if(fields)fields.hidden=!wantsInitials();
 }
 radios.forEach(r=>r.addEventListener('change',update));
 if(personalize)personalize.addEventListener('change',()=>{update();if(personalize.checked&&initials)initials.focus()});
 if(initials)initials.addEventListener('input',()=>{initials.value=initials.value.toUpperCase().replace(/[^A-Z]/g,'').slice(0,3)});
 button.addEventListener('click',async()=>{
  const pack=selected();if(!pack){feedback.textContent='Please select an available pack.';return}
  let lettering='';
  if(wantsInitials()){lettering=(initials&&initials.value.trim())||'';if(lettering.length<2){if(initials)initials.focus();feedback.textContent='Enter 2 or 3 initials.';feedback.classList.add('hmd-alert');return}}
  button.disabled=true;button.setAttribute('aria-busy','true');feedback.textContent='Adding to your bag…';feedback.classList.remove('hmd-alert');
  try{
   const units=Number(pack.dataset.units)||1;
   const props={'_units':String(units)};
   const items=[];
   if(lettering){
     const group='HMD-'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);
     props['Initials']=lettering;props['_group']=group;
     items.push({id:Number(pack.value),quantity:1,properties:props});
     items.push({id:addonId,quantity:units,properties:{'Initials':lettering,'For':units+' holder'+(units>1?'s':''),'_group':group}});
   }else{
     items.push({id:Number(pack.value),quantity:1,properties:props});
   }
   const url=(picker.dataset.cartAdd||root()+'cart/add')+'.js';
   const response=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
   if(!response.ok){const body=await response.json().catch(()=>({}));throw Error(body.description||body.message||'Could not add to your bag. Please try again.')}
   window.location.assign(picker.dataset.cartPage||root()+'cart');
  }catch(error){feedback.textContent=error.message||'Please try again.';feedback.classList.add('hmd-alert');button.disabled=false;button.removeAttribute('aria-busy')}
 });
 update();
}

/* Keep personalization quantity tied to its pack on the cart page. */
function setupCart(cart){
 const form=cart.querySelector('#cart-form');if(!form)return;
 const rows=[...form.querySelectorAll('tr[data-hmd-group]')];
 const addonRows=g=>rows.filter(r=>r.dataset.hmdGroup===g&&r.hasAttribute('data-hmd-addon'));
 rows.filter(r=>!r.hasAttribute('data-hmd-addon')).forEach(row=>{
  const g=row.dataset.hmdGroup;const units=Number(row.dataset.hmdUnits)||1;
  const qty=row.querySelector('[data-hmd-qty]');
  const sync=()=>addonRows(g).forEach(a=>{const q=a.querySelector('[data-hmd-qty]');if(q)q.value=Math.max(0,Number(qty.value)||0)*units});
  if(qty)qty.addEventListener('input',sync);
  const remove=row.querySelector('[data-hmd-remove]');
  if(remove&&qty)remove.addEventListener('click',e=>{e.preventDefault();qty.value=0;sync();
    const h=document.createElement('input');h.type='hidden';h.name='update';h.value='1';form.appendChild(h);form.submit();});
 });
 // If a pack was removed elsewhere, its personalization is flagged in Liquid (orphan) and stays removable.
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();
